<div class="assessment-card">
  <div class="card-header">
    <div class="title-area">
      <h3>{{ assessment.name }}</h3>
      @if (assessment.isCertifying) {
      <syn-certified-assessment-icon />
      }
    </div>

    <div class="header-actions">
      @if (!assessment.isCertifying) {
      <button
        matTooltip="Rendre le questionnaire certifiant"
        (click)="makeCertifying(assessment.id)"
        class="icon-btn primary"
        type="button">
        <span class="material-symbols-outlined">verified</span>
      </button>
      }
      <div class="download-btn">
        <button type="button" class="icon-btn" data-bs-toggle="dropdown" aria-expanded="false" title="Télécharger">
          <span class="material-symbols-outlined">download</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item" (click)="downloadAssessmentCsv(assessment.id, assessment.name)">
              <span class="material-symbols-outlined me-2" style="font-size: 18px">description</span>
              Questionnaire (CSV)
            </a>
          </li>
          <li>
            <a class="dropdown-item" (click)="downloadStatsReport(assessment.id, assessment.name)">
              <span class="material-symbols-outlined me-2" style="font-size: 18px">analytics</span>
              Résultats (CSV)
            </a>
          </li>
        </ul>
      </div>
      <button
        (click)="deleteAssessment(assessment.id)"
        matTooltip="Supprimer le questionnaire"
        class="icon-btn danger"
        type="button">
        <span class="material-symbols-outlined">delete</span>
      </button>
    </div>
  </div>

  <div class="card-body">
    <p class="card-text">{{ assessment.description }}</p>
  </div>

  <div class="card-footer">
    <button
      matTooltip="Upload du cours"
      class="action-btn accent"
      (click)="uploadNewLesson(assessment.id)"
      type="button">
      <span class="material-symbols-outlined">upload_file</span>
      <span>Upload</span>
    </button>

    @if (assessment.hasLesson) {
    <button
      matTooltip="Download du cours"
      class="action-btn neutral"
      (click)="downloadLesson(assessment.id)"
      type="button">
      <span class="material-symbols-outlined">file_save</span>
      <span>Download</span>
    </button>
    }

    <button
      matTooltip="Consulter les résultats du test"
      class="action-btn outline"
      [routerLink]="['/stats', assessment.id]"
      type="button">
      <span class="material-symbols-outlined">insert_chart</span>
      <span>Stats</span>
    </button>

    <button
      matTooltip="Aperçu du questionnaire"
      class="action-btn neutral"
      (click)="previewAssessment(assessment.id)"
      type="button">
      <span class="material-symbols-outlined">visibility</span>
      <span>Aperçu</span>
    </button>
  </div>
</div>
